import useDiscard from "../../useDiscard";
import useWeakMap from "../../utils/useWeakMap";


const store = useWeakMap();
window['templateStore'] = store;

const generateUID = (() => {
    let count = 0;
    return () => Symbol(`templateUUID-#${++count}`)
})()

export const useTemplateIdentity = (propsRoot, propsChild, templateName) => {
    if (!store.has(propsRoot)) {
        store.set(propsRoot, {
            uuid: generateUID(),
            name: templateName
        })
        useDiscard(propsRoot, () => store.delete(propsRoot))

    }
    if (typeof propsChild === 'object' && propsChild !== null && store.has(propsRoot)) {
        store.set(propsChild, store.get(propsRoot));
        useDiscard(propsChild, () => store.delete(propsChild))
    }

    return store.get(propsRoot);
}

export const getTemplateId = (props) => store.get(props)?.uuid;

export const getTemplateName = (props) => store.get(props)?.name;